<div class="jumbotron centered-text">
	<b>{{data.selectEntities.count}}</b> listů vlastnictví bude přiděleno uživateli <b>{{data.details.user | username}}</b>.
</div>
